// extracted by mini-css-extract-plugin
module.exports = {"disable_breadcrumb":"breadCrumbItemComponent_disable_breadcrumb__ua4eP","last_title":"breadCrumbItemComponent_last_title__59A8z"};